import React from "react";
import { Flex } from "../../../Flex";
import { Span } from "../../../Span";
import { Box } from "../../../Box";
import { DisconnectionDetails } from "../../../../types/DisconnectionDetails";
import { DisconnectionDetailsReason } from "../DisconnectionDetailsReason";
import { DisconnectionDetailsIssues } from "../DisconnectionDetailsIssues";
import { DisconnectionDetailsHazards } from "../DisconnectionDetailsHazards";
import { DisconnectionDetailsOtherInfo } from "../DisconnectionDetailsOtherInfo";
import { DisconnectionDetailsDate } from "../DisconnectionDetailsDate";

interface Props {
  id: string;
  disconnectionDetails: DisconnectionDetails;
}

export const DisconnectionDetailsForm: React.FC<Props> = ({
  id,
  disconnectionDetails,
}) => {
  return (
    <Box id={id}>
      <Flex mb={4}>
        <Span
          display="inline-block"
          fontSize={4}
          lineHeight={4}
          fontWeight="medium"
        >
          Disconnection details
        </Span>
      </Flex>

      <Flex
        flexDirection="column"
        flexGrow={0.3}
        flexBasis={0}
        minWidth={["100%", "100%", "100%", 0]}
        mb={[3, 3, 3, 0]}
      >
        <DisconnectionDetailsReason id={`${id}-disconnection-reason`} />
        <DisconnectionDetailsDate
          id={`${id}-disconnection-date`}
          disconnectionDate={disconnectionDetails.disconnectionDate}
        />
        <DisconnectionDetailsIssues
          id={`${id}-disconnection-issues`}
          hasTenants={disconnectionDetails.hasTenants}
        />
        <DisconnectionDetailsHazards id={`${id}-disconnection-hazards`} />
        <DisconnectionDetailsOtherInfo id={`${id}-disconnection-other-info`} />
      </Flex>
    </Box>
  );
};
